export default __webpack_public_path__ + "static/media/no-data-image.88d464fd.svg";